import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import toast from 'react-hot-toast'

interface ProvisionTwilioNumberParams {
  user_id?: number
  organization_id?: number
  phone_number?: string
  area_code?: string
}

interface ProvisionTwilioNumberResponse {
  id: number
  number: string
  sid: string
  user_id: number
  organization_id: number
  active: boolean
}

const provisionTwilioNumber = async (
  params: ProvisionTwilioNumberParams
): Promise<ProvisionTwilioNumberResponse> => {
  let response = await fetch(
    `${BASE_API_URL}/admin/api/v2/phone_numbers/provision`,
    {
      method: API_METHODS.POST,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify(params),
    }
  )
  response = handleErrors(response)
  const json = await response.json()
  return json.data
}

const useProvisionTwilioNumber = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (params: ProvisionTwilioNumberParams) => provisionTwilioNumber(params),
    {
      onSuccess: (data) => {
        toast(`Phone number ${data.number} provisioned successfully`, {
          icon: '📞',
        })
        // Invalidate user details query to refresh the phone number data
        queryClient.invalidateQueries(['user-detail'])
        queryClient.invalidateQueries(['apple_id_by_user_id'])
      },
      onError: (error: Error) => {
        console.error('Error provisioning Twilio number:', error)
        toast('Failed to provision phone number. Please try again.')
      },
    }
  )
}

export default useProvisionTwilioNumber
